import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isLoading: false,
        currentUser: null,
        allRecipes: []
    },
    mutations: {
        setLoading(state, setLoading) {
            state.isLoading = setLoading
        },
        setCurrentUser(state, user) {
            state.currentUser = user
        },
        setRecipes(state, allRecipes) {
            state.allRecipes = allRecipes
        }
    },
    actions: {
        setLoading(context, loadingState) {
            context.commit('setLoading', loadingState)
        },
        setCurrentUser(context, user) {
            if (user != null) {
                user = {
                    displayName: user.displayName,
                    email: user.email,
                    emailVerified: user.emailVerified,
                    photoURL: user.photoURL,
                    uid: user.uid,
                    providerData: user.providerData
                }
            }
            context.commit('setCurrentUser', user)
        },
        setRecipes(context, allRecipes) {
            context.commit('setRecipes', allRecipes)
        }
    },
    plugins: [createPersistedState()]
})